import { Card } from '@/components/ui';
import { useMatters } from '@/contexts/MatterContext';

interface AnchorBannerProps {
  matterId: string | null;
}

// Pinned banner for the hearing right column. Always shows the active matter's
// anchor point so the operator stays locked onto the one point that wins the
// matter. Subtle amber panel per 03-ui-design-language.md (Card "accent").
export function AnchorBanner({ matterId }: AnchorBannerProps) {
  const { matters } = useMatters();
  const matter = matterId ? (matters.find((m) => m.id === matterId) ?? null) : null;
  const anchor = matter?.anchorPoint?.trim() ?? '';

  return (
    <Card variant="accent" padding="md">
      <p className="text-[10px] uppercase tracking-[0.2em] text-amber-400">Your one point</p>
      {anchor ? (
        <p className="mt-2 text-sm leading-snug text-stone-100">{anchor}</p>
      ) : (
        <p className="mt-2 text-sm text-stone-500">No anchor point set for this matter</p>
      )}
    </Card>
  );
}
